<template>
  <b-container fluid class="no-bottom">
    <b-row>
      <b-col class="d-flex">
        <backlink class="mt-20" />
        <div class="flex-grow-1">
          <h1>Debug scan</h1>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex">
        <input
          type="text"
          v-model="internal_code"
          @input="onInput"
          @keydown="onKeydown"
          placeholder="Scanner une référence unique ou un produit à la vente"
          class="form-control"
          ref="internal_code"
        />
      </b-col>
    </b-row>
    <b-row class="mt-15">
      <b-col class="d-flex">
        <b-button variant="primary" @click="runLookup" :disabled="!internal_code"
          >Tester la recherche (sans redirection)</b-button
        >
        <b-button variant="secondary" class="ml-10" @click="reset">Réinitialiser</b-button>
      </b-col>
    </b-row>

    <b-row class="mt-25">
      <b-col>
        <h2>Analyse de la valeur reçue</h2>
        <pre class="debug-block">{{ JSON.stringify(analysis, null, 2) }}</pre>
      </b-col>
    </b-row>

    <b-row class="mt-25">
      <b-col>
        <h2>Journal des évènements "input" ({{ inputLog.length }})</h2>
        <pre class="debug-block scroll">{{ JSON.stringify(inputLog, null, 2) }}</pre>
      </b-col>
    </b-row>

    <b-row class="mt-25">
      <b-col>
        <h2>Journal des évènements "keydown" ({{ keyLog.length }})</h2>
        <pre class="debug-block scroll">{{ JSON.stringify(keyLog, null, 2) }}</pre>
      </b-col>
    </b-row>

    <b-row class="mt-25" v-if="result">
      <b-col>
        <h2>Résultat de la recherche</h2>
        <pre class="debug-block">{{ JSON.stringify(result, null, 2) }}</pre>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "ReferenceMobileScanDebug",
  data() {
    return {
      internal_code: null,
      inputLog: [],
      keyLog: [],
      lastEventTime: null,
      result: null,
    };
  },
  computed: {
    analysis() {
      const value = this.internal_code || "";
      return {
        raw: value,
        json: JSON.stringify(value),
        type: typeof this.internal_code,
        length: value.length,
        trimmedLength: value.trim().length,
        isNumeric: /^[0-9]+$/.test(value),
        hasLeadingZero: /^0[0-9]/.test(value),
        hasWhitespace: /\s/.test(value),
        hasControlChars: /[\x00-\x1F\x7F]/.test(value),
        charCodes: Array.from(value).map((c) => c.charCodeAt(0)),
      };
    },
  },
  mounted() {
    this.$store.dispatch("product/getAll");
    this.$refs.internal_code.focus();
  },
  methods: {
    onInput: function (event) {
      const now = performance.now();
      const deltaMs = this.lastEventTime === null ? null : Math.round(now - this.lastEventTime);
      this.lastEventTime = now;
      this.inputLog.push({
        time: new Date().toISOString(),
        deltaMs: deltaMs,
        data: event.data,
        inputType: event.inputType,
        valueLength: event.target.value.length,
        value: event.target.value,
      });
    },
    onKeydown: function (event) {
      this.keyLog.push({
        time: new Date().toISOString(),
        key: event.key,
        code: event.code,
        keyCode: event.keyCode,
      });
    },
    /**
     * Reproduit la recherche de ReferenceMobileScan.getReferenceOrProduct, mais sans jamais rediriger :
     * le résultat brut (ou l'erreur brute) est affiché dans la page.
     */
    runLookup: function () {
      const internal_code = this.internal_code;
      const product = this.$store.getters["product/getItemByInternalCode"](internal_code);

      if (product) {
        this.result = {
          source: "product/getItemByInternalCode (getter local)",
          found: true,
          type: "product",
          data: product,
        };
        return;
      }

      this.result = { source: "POST reference/available", type: "reference", status: "en cours..." };
      this.$store
        .dispatch("reference/isAvailable", internal_code)
        .then((reference) => {
          this.result = {
            source: "POST reference/available",
            found: !!reference,
            type: "reference",
            data: reference,
          };
        })
        .catch((error) => {
          this.result = {
            source: "POST reference/available",
            found: false,
            type: "reference",
            error: {
              message: error.message,
              status: error.response ? error.response.status : null,
              data: error.response ? error.response.data : null,
            },
          };
        });
    },
    reset: function () {
      this.internal_code = null;
      this.inputLog = [];
      this.keyLog = [];
      this.lastEventTime = null;
      this.result = null;
      this.$nextTick(() => this.$refs.internal_code.focus());
    },
  },
};
</script>

<style lang="scss" scoped>
.debug-block {
  background: #1e1e1e;
  color: #d4d4d4;
  padding: 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
}
.debug-block.scroll {
  max-height: 250px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ReferenceMobile/ReferenceMobileScanDebug.vue